import { GrossProfitMarginResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  result: GrossProfitMarginResult;
  translations: ToolsTranslations['grossProfitMargin'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  if (!result.isValid) {
    return (
      <div className="space-y-6">
        <h3 className="text-lg font-medium text-gray-900">{translations.results.title}</h3>
        <div className="p-4 bg-red-50 border border-red-200 rounded-md">
          <p className="text-sm text-red-600">{result.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900">{translations.results.title}</h3>
      
      <div className="space-y-4">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <div className="text-center">
            <p className="text-sm text-blue-600 mb-2">{translations.results.grossProfitLabel}</p>
            <p className="text-3xl font-bold text-blue-900">
              {result.grossProfit?.toLocaleString('sv-SE')} kr
            </p>
          </div>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-lg p-6">
          <div className="text-center">
            <p className="text-sm text-green-600 mb-2">{translations.results.marginLabel}</p>
            <p className="text-3xl font-bold text-green-900">
              {result.marginPct?.toFixed(2)} %
            </p>
          </div>
        </div>
      </div>

      <div className="text-sm text-gray-600 space-y-2">
        <p>{translations.results.explanation}</p>
        {result.grossProfit !== null && result.grossProfit < 0 && (
          <p className="text-amber-600 font-medium">{translations.results.negativeProfit}</p>
        )}
        {result.marginPct !== null && result.marginPct < 0 && (
          <p className="text-amber-600 font-medium">{translations.results.negativeMargin}</p>
        )}
      </div>
    </div>
  );
}
